import ErrorToast from './ErrorToast';

export default ErrorToast;
